import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";

import toast from "react-hot-toast";
import { useEffect, useState } from "react";

import { getProfil } from "client/sharedClient";
import { meSekolah } from "client/SekolahClient";
import { ppdbURL, ssURL } from "client/clientAxios";
import { activate, sendActivationCode } from "client/UserClient";

import useTa from "hooks/useTa";
import useUser from "hooks/useUser";
import useBagian from "hooks/useBagian";
import useSekolah from "hooks/useSekolah";
import useWaBot from "hooks/useWhatsappBot";
import useUserSiswa from "hooks/useUserSiswa";

import { hideModal } from "utilities/ModalUtils";
import { detectBrowser } from "utilities/detectBrowserUtils";

import Help from "../Help/Help";
import ModalAktivasi from "./ModalAktivasi";
import Header from "../Shared/Header/Header";
import OperatorHeader from "../Shared/Header/OperatorHeader";
import BottomNavigation from "../Shared/Header/BottomNavigation";

const browserList = ["Edge", "Opera", "Chrome", "Firefox", "Safari"];

const Layout = ({
  children,
  isFluid,
  modalWrapper,
  isIndex,
  isDashboard,
  token,
  isCenteredPage,
}) => {
  const router = useRouter();
  const { setUser, user } = useUser();
  const { setUserSiswa } = useUserSiswa();
  const { setSekolah, sekolah } = useSekolah();
  const { setBagian } = useBagian();
  const { setWaBot } = useWaBot();
  const { setTa, ta } = useTa();

  const [buttonAktivasi, setButtonAktivasi] = useState("idle");
  const [formData, setFormData] = useState({ whatsapp: "", email: "" });

  const checkUserAgent = (examBro) => {
    const detected = detectBrowser();
    if (examBro?.user_agent && browserList.includes(detected)) {
      toast.error("Harap Buka di SafeExamBrowser");
      router.push(`${ssURL}/login`);
    }
  };

  const getMeSekolahData = async () => {
    const { data } = await meSekolah();
    if (data) {
      if (data?.sekolah?.domainBackup && !location.href.includes(data?.sekolah?.domainBackup)) {
        router.push(data?.sekolah?.domainBackup);
        return;
      }
      setSekolah(data.sekolah);
      setWaBot(data.whatsappBot);
      return data.sekolah;
    }
  };

  const getProfilData = async (profileSekolah) => {
    const { data, status } = await getProfil();
    if (status === 200 && data) {
      if (data.user?.role === "ppdb") return router.push(`${ppdbURL}`);

      setUser(data.user);
      setTa(data.ta);
      setUserSiswa(data.userSiswa);

      if (
        data.user?.role === "siswa" &&
        [8123, 8027, 12404].includes(profileSekolah?.id)
      ) {
        checkUserAgent(JSON?.parse(profileSekolah?.fitur?.fitur));
      }
    } else if ([401, 403].includes(status)) {
      router.push(`${ssURL}/login`);
    }
  };

  const sendActivation = async (wa) => {
    const { data, error } = await sendActivationCode({ ...formData, whatsapp: wa || "" });
    if (data) {
      toast.success("Kode verifikasi terkirim");
      setFormData((prev) => ({ ...prev, terkirim: 1, data: data.message }));
    } else {
      toast.error(error?.message?.message || "Gagal mengirim kode");
    }
  };

  const aktifkan = async () => {
    setButtonAktivasi("loading");
    const { data, error } = await activate({ ...formData });
    if (data) {
      toast.success(data.message);
      setButtonAktivasi("success");
      setFormData({ whatsapp: "", email: "" });
      getProfilData();
      hideModal("modalAktivasi");
    } else {
      toast.error(error?.message || "Aktivasi gagal");
      setButtonAktivasi("error");
    }
  };

  useEffect(() => {
    getMeSekolahData()
      .then((sekolah) => {
        return getProfilData(sekolah); // pakai data sekolah langsung, bukan dari hook
      })
      .catch((err) => {
        console.error("Error saat memuat data:", err);
      });

    if (token) {
      localStorage.setItem("ss-token", JSON.stringify(token));
    }
  }, []);

  useEffect(() => {
    if (user?.role === "admin" && ta === 404) {
      toast.success("Aktifkan Tahun Akademik sebelum memulai penggunaan Smarteschool");
      setBagian("kurikulum");
      router.push("/smartschool/tahun-akademik-v2");
    }
  }, [ta]);

  useEffect(() => {
    setBagian(
      user?.bagian?.split(";").length == 1
        ? user?.bagian?.split(";")[0]
        : localStorage.getItem("bagian") || ""
    );
  }, [user]);

  //  useEffect(() => {
  //     if (user.userAgent != window.navigator.userAgent) {
  //        console.log(user.userAgent);
  //        console.log(window.navigator.userAgent);
  //        router.push(`${ssURL}/login`);
  //        toast.success("Berhasil masuk di perangkat lain");
  //     }
  //  }, [user]);

  return (
    <div className="smartschool-app">
      <Head>
        <title>Smarteschool</title>
        <link rel="shortcut icon" href={sekolah?.favicon} />
      </Head>
      {user?.role == "admin" || user?.role == "kurikulum" ? (
        <OperatorHeader />
      ) : (
        <Header />
      )}
      <main
        className={`${isIndex ? "bg-light" : "bg-main"} ${isCenteredPage
          ? "d-flex align-items-center justify-content-center"
          : ""
          }`}
      >
        {/* {!user?.waReal &&
          user?.role != "admin" &&
          user?.role != "pengawas" &&
          Object.keys(user).length != 0 && ( */}
        {/* <> */}
        {/* <div */}
        {/* // className="w-100 d-flex justify-content-center text-white sticky-top py-3 px-4 notification-bar-verification bg-warning" */}
        {/* // style={{
                //   background: `url("/img/bg-verification-${
                //     user?.waReal ? (user?.email ? "" : "email") : "whatsapp"
                //   }.svg")`,
                // }}
                // data-bs-toggle="modal"
                // data-bs-target="#modalAktivasi" */}
        {/* > */}
        {/* <div className="d-flex align-items-sm-center align-items-start">
                  <Image
                    src="/img/exclamation-notification-bar.svg"
                    alt="icon"
                    className="me-3"
                  />
                  <span>
                    Anda belum mengaktifkan fitur notifikasi. */}
        {/* {user?.waReal
                    ? user?.email
                      ? ""
                      : "Email"
                    : "Nomor WhatsApp"}{" "}
                  Anda.  */}
        {/* Klik{" "}
                    <span className="fw-extrabold text-decoration-underline">
                      disini
                    </span>{" "}
                    untuk mengaktifkan fitur dengan{" "}
                    {user?.waReal
                      ? user?.email
                        ? ""
                        : "email"
                      : "nomor whatsapp"}{" "}
                    Anda
                  </span> */}
        {/* </div>
              </div>
            </>
          )} */}
        <div
          className={`${isDashboard
            ? "container-fluid py-4 px-xl-5 px-4"
            : isFluid
              ? "container-fluid py-4"
              : "container py-4"
            }`}
        >
          {children}
        </div>
      </main>
      {user?.role == "siswa" || user?.role == "guru" ? (
        <BottomNavigation />
      ) : (
        ""
      )}
      <ModalAktivasi
        isWhatsapp={user?.waReal ? 0 : 1}
        buttonAktivasi={buttonAktivasi}
        formData={formData}
        setFormData={setFormData}
        sendActivation={sendActivation}
        aktifkan={aktifkan}
      />
      {modalWrapper}
      <footer className="bg-light">
        <div className="container py-4 text-center">
          <small>
            &copy;Smarteschool {new Date().getFullYear()}. Hak Cipta Dilindungi
            oleh Undang-undang.
            <br />
            <a
              href="https://smarteschool.id"
              target="_blank"
              rel="noreferrer noopener"
              className="text-decoration-none"
            >
              Powered by Smarteschool.
            </a>
          </small>
        </div>
      </footer>
      <Help />
    </div>
  );
};

export default Layout;
